import { requirePropFactory } from '@material-ui/core'
import React from 'react'
import {Link, useHistory, Redirect} from 'react-router-dom'
import './styles.css'

function Rodape(){

    return (

   <footer className='rodapenovoCia'>
       <div className='rodapecima'>
       <Link to={{pathname: `/`}}>
       <img src={require('../../images/rodape.jpg')} className='img-fluid logorodapeCia' />
                                </Link>
       
        <div className='contredes' >
         <span>Siga-nos nas redes sociais</span>
         <div className='contlogosCia'>
            <a  onClick={()=> window.open('https://www.facebook.com/arcoiristintasrg/', "_blank")} ><img src={require('./image 16.png')} className='img-fluid redeslogo' /></a> 
            <a  onClick={()=> window.open('https://www.instagram.com/arcoiristintasrg/', "_blank")} ><img src={require('./image 15.png')} className='img-fluid redeslogo' /></a> 
            <a  onClick={()=> window.open('https://api.whatsapp.com/send?phone=5553999765703', "_blank")} ><img src={require('./image 14.png')} className='img-fluid redeslogo' /></a> 
         </div>
         <div className='contlogosCia' style={{marginTop: '30px'}}>
            <img src={require('./image 18.png')} className='img-fluid redeslogo' />
            <span className='tel'>(53) 3231-4050</span>
         </div>
        </div>
       </div>
       <div className='rodapemeio'>
        <a href='https://www.google.com/maps/place/Arco-%C3%8Dris+Tintas/@-32.0403288,-52.1089771,15z/data=!4m2!3m1!1s0x0:0xf0c34185c1566ca1?sa=X&ved=2ahUKEwiGqdO_-q-CAxV5p5UCHW1SDKIQ_BJ6BAhYEAA' target='_blank'><span>Venha nos visitar</span></a>
        <span>R. Cristóvão Colombo, 537 - Cidade Nova, Rio Grande - RS</span>
        <span>Segunda a Sexta das 08:30 às 12:00 e das 13:30 às 18:30  <br/> Sábados das 08:30 às 12:30</span>
       </div>
       <div className='rodapefim'>
        <div className='containertradeinfo'>
        <span style={{cursor:'pointer'}} onClick={() => window.open('http://tradesystem.com.br/', '_blank')}>Copyright © Todos os DIreitos Reservados | Sistema produzido e distribuido por Trade System</span>
        </div>
       </div>
        
   </footer>
    )
}

export default Rodape

/*
<a  onClick={()=> window.open("https://api.whatsapp.com/send?phone=5553991087357&text=A%20melhor%20companhia%20para%20o%20seu%20ve%C3%ADculo", "_blank")} ><img src={require('./image 14.png')} className='img-fluid redeslogo' /></a> 
<a ><img src={require('./image 15.png')} className='img-fluid redeslogo' onClick={()=> window.open("https://www.instagram.com/diskaguagasebebidas1101/", "_blank")} /></a>             
*/ 